<mat-accordion class="summary__payments">
	<mat-expansion-panel>
		<mat-expansion-panel-header>
			<mat-panel-title>Generator dokumentów</mat-panel-title>
		</mat-expansion-panel-header>
		<mat-card appearance="outlined">
			<mat-card-content>
				<div>
					<mat-form-field appearance="outline">
						<mat-label>Wybierz dokument</mat-label>
						<mat-select [(ngModel)]="selectedDocumentName">
							<mat-option *ngFor="let document of documentToGenerate" [value]="document.name">{{
								document.displayName
							}}</mat-option>
						</mat-select>
					</mat-form-field>
					<button (click)="generateDocument()" mat-raised-button class="ms-3" color="primary">
						<i class="fa-solid fa-file me-2"></i>Generuj dokument
					</button>
					<button mat-raised-button class="ms-3" color="primary" (click)="Input.click()">
						<i class="fas fa-file-upload me-2"></i>Załącz dokument
					</button>
					<input
						class="d-none attach-document-input"
						type="file"
						[multiple]="true"
						(change)="attachDocuments($event)"
						#Input
						name="attachDocument"
					/>
				</div>
				<mat-progress-bar mode="indeterminate" *ngIf="showProgressBar"></mat-progress-bar>
				<!--hidden for now-->
				<mat-checkbox hidden color="primary"
					>Zaznacz, jeśli chcesz automatycznie wysłać do klienta</mat-checkbox
				>
				<mat-card-title class="fs-5 mt-2">Lista dokumentów</mat-card-title>

				<div
					class="w-100 d-flex cursor-pointer text-center justify-content-between align-items-center py-2 border-bottom"
					*ngFor="let document of documentList; trackBy: trackByDocumentId"
					(click)="clickDocument(document)"
				>
					<i class="fa-solid fa-file pe-2 w-5"></i>
					<span class="pe-2 w-35">{{ document?.name }}</span>
					<span class="pe-2 w-15"
						>{{ dateService.apiToDateTime(document?.createdAt).date }}
						|
						{{ dateService.apiToDateTime(document?.createdAt).time }}</span
					>
					<span class="pe-2 w-45">
						{{ document?.createdBy.firstName }}
						{{ document?.createdBy.lastName }}
						{{ document?.createdBy.email }}
					</span>
				</div>
			</mat-card-content>
		</mat-card>
	</mat-expansion-panel>
</mat-accordion>
